"use strict";
document.addEventListener("DOMContentLoaded", function () {
  var adpPopup = {};
  (function () {
    var $this;
    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",
      init: function (e) {
        $this = adpPopup;
        $this.popupInit(e);
        $this.events(e);
      },
      events: function (e) {
        document.addEventListener("click", function (event) {
          if (
            event.target.matches(".popup-close") ||
            event.target.closest(".popup-close") ||
            event.target.matches(".popup-decline-button") ||
            event.target.closest(".popup-decline-button")
          ) {
            $this.closePopup(event);
          }
          if (
            event.target.matches(".popup-accept") ||
            event.target.closest(".popup-accept")
          ) {
            $this.acceptPopup(event);
            $this.closePopup(event);
          }
          if (
            event.target.matches(".age-verification__popup-close") ||
            event.target.closest(".age-verification__popup-close")
          ) {
            $this.agePopup(event);
            $this.closePopup(event);
          }
          if (
            event.target.matches(".age-verification__button-no") ||
            event.target.closest(".age-verification__button-no")
          ) {
            $this.ageDeclined(event);
          }
        });
        document.addEventListener("keyup", function (event) {
          if (event.key === "Escape") {
            document
              .querySelectorAll('.popup-open[data-esc-close="true"]')
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }
          if (event.key === "F4") {
            document
              .querySelectorAll('.popup-open[data-f4-close="true"]')
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }
        });
        document.querySelectorAll(".popup-overlay").forEach((element) => {
          element.addEventListener("click", (event) => {
            if (
              element.previousElementSibling.matches(
                '.popup-open[data-overlay-close="true"]'
              )
            ) {
              $this.closePopup(element.previousElementSibling);
            }
          });
        });
      },
      popupInit: function (e) {
        document.addEventListener("scroll", function () {
          let scrollCurrent = window.scrollY;
          if (scrollCurrent > $this.sPrevious) {
            $this.sDirection = "down";
          } else {
            $this.sDirection = "up";
          }
          $this.sPrevious = scrollCurrent;
        });
        document.querySelectorAll(".popup").forEach(function (popup) {
          if ("manual" === popup.getAttribute("data-open-trigger")) {
            let selector = popup.getAttribute("data-open-manual-selector");
            if (selector) {
              const onTriggerClick = (event) => {
                event.preventDefault();
                if (
                  event.target.closest(".popup-close") ||
                  event.target.closest(".popup-overlay") ||
                  event.target.closest(".popup-button")
                ) {
                  popup.classList.remove("popup-already-opened");
                  $this.openPopup(popup);
                  if (event.target.classList.contains("popup")) {
                    $this.closePopup(selector);
                  }
                }
              };
              const triggerInteraction = (triggerElement) => {
                if (!triggerElement) return;
                triggerElement.addEventListener("click", onTriggerClick);
                const isClickableOverlay =
                  triggerElement.getAttribute("data-overlay-close") === "true";
                const overlay = triggerElement.nextElementSibling;
                if (
                  isClickableOverlay &&
                  overlay &&
                  overlay.classList.contains("popup-overlay")
                ) {
                  overlay.addEventListener("click", onTriggerClick);
                }
              };
              let triggerEl;
              if (selector.charAt(0) == "#") {
                triggerEl = document.getElementById(selector.slice(1));
              } else {
                triggerEl = document.querySelector(selector);
              }
              triggerInteraction(triggerEl);
            }
          }
          if (
            !$this.isAllowPopup(popup) &&
            !popup.classList.contains("age-verification")
          ) {
            return;
          }
          $this.openTriggerPopup(popup);
        });
      },
      openTriggerPopup: function (popup) {
        let trigger = popup.getAttribute("data-open-trigger");
        if (trigger === "none") {
          let ageVerification = $this.getStorage(
            "popup-age-" + (popup.getAttribute("data-id") || 0)
          );
          if (!ageVerification || Shopify.designMode) {
            $this.openPopup(popup);
          }
        }
        const hasAcceptBtn = popup.querySelector(".popup-accept");
        if (hasAcceptBtn) {
          let accept = $this.getStorage(
            "popup-accept-" + (popup.getAttribute("data-id") || 0)
          );
          if (accept && !Shopify.designMode) {
            trigger = "accept";
            return;
          }
        }
        if (trigger === "delay") {
          setTimeout(function () {
            $this.openPopup(popup);
          }, parseInt(popup.getAttribute("data-open-delay-number")) * 1000);
        }
        if (trigger === "exit") {
          var showExit = true;
          document.addEventListener("mousemove", function (event) {
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (event.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-open-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-open-scroll-position")
          );
          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
          });
        }
      },
      closeTriggerPopup: function (popup) {
        var trigger = popup.getAttribute("data-close-trigger");
        if (trigger === "delay") {
          setTimeout(function () {
            $this.closePopup(popup);
          }, parseInt(popup.getAttribute("data-close-delay-number")) * 1000);
        }
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-close-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-close-scroll-position")
          );
          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
          });
        }
      },
      openPopup: function (popup) {
        if (popup.classList.contains("popup-already-opened")) {
          return;
        }
        if (popup.classList.contains("popup-open")) {
          return;
        }
        if (popup.getAttribute("data-body-scroll-disable") === "true") {
          document.body.classList.add("popup-scroll-hidden");
          if (popup.getAttribute("data-mobile-disable") === "false") {
            document.body.classList.add("popup-scroll-hidden-mobile");
          }
        }
        const key = "popup-" + popup.getAttribute("data-id");
        const limit = parseInt($this.getStorage(key) || 0) + 1;
        $this.setStorage(key, limit, {
          expires: popup.getAttribute("data-limit-lifetime"),
        });
        popup.classList.add("popup-open");
        popup.setAttribute("data-init-scroll-px", window.scrollY);
        popup.setAttribute(
          "data-init-scroll-percent",
          $this.getScrollPercent()
        );
        let animation = popup.getAttribute("data-open-animation");
        $this.applyAnimation(popup, animation);
        $this.closeTriggerPopup(popup);
        popup.focus();
      },
      agePopup: function (event) {
        let el = event.target ? event.target : event;
        let popup = el.closest(".popup");
        $this.setStorage("popup-age-" + popup.getAttribute("data-id"), 1, {
          expires: 360,
        });
      },
      ageDeclined: function () {
        document
          .querySelectorAll(".age-verification__question")
          .forEach(function (el) {
            el.classList.remove("show");
          });
        document
          .querySelector(".age-verification__declined")
          ?.classList.add("show");
        if (!window.Shopify.designMode) {
          document.querySelectorAll(".shopify-section").forEach((el) => {
            if (!el.classList.contains("age-verification-section")) {
              el.remove();
            }
          });
        }
      },
      acceptPopup: function (event) {
        let el = event.target ? event.target : event;
        let popup = el.closest(".popup");
        $this.setStorage("popup-accept-" + popup.getAttribute("data-id"), 1, {
          expires: 360,
        });
      },
      closePopup: function (event) {
        let el = event.target ? event.target : event;
        let popup = el.closest(".popup");
        let animation = popup.getAttribute("data-exit-animation");
        $this.applyAnimation(popup, animation, function () {
          popup.classList.add("popup-already-opened");
          popup.classList.remove("popup-open");
          popup.blur();
        });
        document.body.classList.remove("popup-scroll-hidden");
        document.body.classList.remove("popup-scroll-hidden-mobile");
      },
      isAllowPopup: function (popup) {
        let limitDisplay = parseInt(
          popup.getAttribute("data-limit-display") || 0
        );
        let limitDisplayStored = parseInt(
          $this.getStorage("popup-" + popup.getAttribute("data-id"))
        );
        if (
          !Shopify.designMode &&
          limitDisplay &&
          limitDisplayStored &&
          limitDisplayStored >= limitDisplay
        ) {
          return false;
        }
        return true;
      },
      applyAnimation: function (el, name, callback) {
        var popup = el.closest(".popup");
        let overlayName;
        if (typeof callback === "function") {
          overlayName = "popupExitFade";
        } else {
          overlayName = "popupOpenFade";
        }
        if (popup.nextElementSibling) {
          popup.nextElementSibling.classList.add("popup-animated", overlayName);
          popup.nextElementSibling.addEventListener(
            "animationend",
            function () {
              this.classList.remove("popup-animated", overlayName);
            }
          );
        }
        popup
          .querySelector(".popup-wrap")
          .classList.add("popup-animated", name);
        popup
          .querySelector(".popup-wrap")
          .addEventListener("animationend", function () {
            this.classList.remove("popup-animated", name);
            if (typeof callback === "function") {
              callback();
            }
          });
      },
      getStorage: function (key) {
        const item = localStorage.getItem(key);
        if (!item) return undefined;
        try {
          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      },
      setStorage: function (key, value, options = {}) {
        const data = {
          value,
          expires: null,
        };
        if (options.expires) {
          const expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },
      getScrollPercent: function () {
        const h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();
  adpPopup.init();
  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });
  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("popup-scroll-hidden");
  });
});
